<template>
  <div v-if="sliders.length" class="reviews-slider">
    <header class="reviews-slider__slider">
      <h3 class="reviews-slider__title title--second">{{$t('reviews_slider_title')}}</h3>
      <div class="product-slider__navigation">
        <div class="swiper-button-prev reviews__swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next reviews__swiper-button-next" slot="button-next"></div>
      </div>
    </header>
    <swiper class="swiper" :options="swiperOption">
      <swiper-slide class="swiper-item" v-for="(answer, i) in sliders" :key="i">
        <CommentCard
          catalog-page
          :key="i"
          :answer-key="i"
          :avatar="answer.user_picture"
          :date="answer.date"
          :rate="answer.rating"
          :productLink="answer.product_link"
          :productName="answer.product_name"
          :name="!answer.is_manager ? answer.user_name : $t('comment.manager')"
          :comment="answer.comment"
          :movedFrom="answer.moved_from"
          :isMoved="answer.is_moved"
          :endpoint="$constants.COMMENTS.ADD_PRODUCT_COMMENT_ENDPOINT"
        />
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
import CommentCard from '../comments/CommentCard'
import { isTouch } from '@/mixins/isTouchDevice'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import { mapGetters } from 'vuex'
import { wordFormatter } from '../../mixins/wordFormatter'
import axios from 'axios'
export default {
  name: 'ReviewsSlider',
  components: {
    Swiper,
    SwiperSlide,
    CommentCard
  },
  props: {
    categoryId: {
      type: Number,
      required: true
    }
  },
  mixins: [isTouch, wordFormatter],
  computed: {
    ...mapGetters(['urlLanguagePrefix'])
  },
  data () {
    return {
      sliders: [],
      swiperOption: {
        watchOverflow: true,
        watchSlidesVisibility: true,
        spaceBetween: 0,
        slidesPerView: 1.2,
        navigation: {
          nextEl: '.reviews__swiper-button-next',
          prevEl: '.reviews__swiper-button-prev'
        },
        simulateTouch: !isTouch,
        touchStartPreventDefault: false,
        preloadImages: false,
        breakpoints: {
          769: {
            slidesPerView: 2
          }
        },
        autoHeight: true
      }
    }
  },
  methods: {
    fetchComments () {
      axios.get(this.urlLanguagePrefix + '/shop/catalog/get-category-comments/?categoryId=' + this.categoryId)
        .then(({ data }) => (this.sliders = data))
    }
  },
  mounted () {
    this.fetchComments()
  }
}
</script>

<style scoped lang="sass">
@import "../../styles/swiper/swiper"

.product-slider__navigation
  position: relative
  width: 80px

.reviews-slider__slider
  display: flex
  justify-content: space-between

.reviews-slider
  margin-bottom: 30px
  margin-top: 30px

.swiper-item
  border: 1px solid #f3f3f3
  height: auto

  &:not(:last-child)
    border-right: 0

.reviews-slider__title
  padding: 0
  margin: 0

.swiper
  margin-top: 20px
</style>
